import { createSlice } from '@reduxjs/toolkit'
import type { PayloadAction } from '@reduxjs/toolkit'
import type { RootState } from '../Store/Store'

type Section = {
  page_id: number
  key: string
  name?: string
  caption?: string
  visible?: boolean
  order?: number
  data?: any
}

const initialState = {
  page_id: NaN,
  key: '',
  name: '',
  caption: '',
  visible: undefined,
  order: undefined,
  data: {},
} as Section

const set = (obj:any, path:any, val:any) => { 
  const keys = path.split(':');
  const lastKey = keys.pop();
  const lastObj = keys.reduce((obj:any, key:any) => 
      obj[key] = obj[key] || {}, 
      obj); 
  lastObj[lastKey] = val;
};

const setNew = (obj:any, path:any) => { 
  const keys = path.split(':');
  const lastKey = keys.pop();
  const lastObj = keys.reduce((obj:any, key:any) => 
      obj[key] = obj[key] || {}, 
      obj); 
  lastObj[lastKey].push({key : "", value : ""});
};

const del = (obj:any, path:any, index:any) => { 
  const keys = path.split(':');
  const lastKey = keys.pop();
  const lastObj = keys.reduce((obj:any, key:any) => 
      obj[key] = obj[key] || {}, 
      obj); 
  lastObj[lastKey].splice(index, 1);
};

const sectionSlice = createSlice({
  name: 'section',
  initialState,
  reducers: {
    setSection: (
      state,
      { payload: {page_id, key, name ,caption,visible,order,data} }: PayloadAction<Section>
    ) => {
      state.page_id = page_id
      state.key = key
      state.name = name
      state.caption = caption
      state.visible = visible
      state.order = order
      state.data = data
    },
    setSectionData: (
      state, { payload: {name,value,checked} }: PayloadAction<any>
    ) => {
      if(name.includes('swh')){ value = checked}
      set(state.data, name, value);
    },
    deleteSectionDataArray: (
      state, { payload: {input,index} }: PayloadAction<any>
    ) => {
      // state.data[input].splice(index, 1)
      del(state.data, input, index)
      // delete state.data[input][index]
    },
    addSectionDataArray: (
      state, { payload: {input} }: PayloadAction<any>
    ) => {
      // state.data[input].push({key : "", value : ""})
      setNew(state.data, input);
    },
  },
})

export const { setSection , setSectionData , deleteSectionDataArray , addSectionDataArray} = sectionSlice.actions

export default sectionSlice.reducer

export const selectSection = (state: RootState) => state.section
